<div class="bg-primary tutor-header-container">
    <span class="tutor-title">
        @switch (data.type) {
            @case('tutor') {
                <img class="tutor-icon" src=".\assets\imgs\ico-tutor.png"/>
            }
            @case('info') {
                <img class="tutor-icon" src=".\assets\imgs\ico-info.png"/>
            }
        }
        <span class="tutor-title-txt">{{data.title}}</span>
    </span>
    @if (data.type == 'info') {
        <span>
            <a class="close-btn" (click)="closeDialog(null)"><i class="fa-solid fa-xmark"></i></a>
        </span>
    }
</div>
<div mat-dialog-content>
    <div class="tutor-content">
        <span>

            @for (cont of data.content; track $index) {
                
                @switch (cont.typo) {

                    @case ('str') {
                        <span [ngStyle]="cont.style">{{cont.str}} </span>
                    }

                    @case ('html') {
                        <span [innerHTML]="cont.str"></span>
                    }

                    @case ('break') {
                        <br />
                    }

                    @case ('click') {
                        <span class="tutor-txt-action" (click)="closeDialog(cont.value)">{{cont.str}}&nbsp;</span>
                    }

                    @case ('btn') {
                        <app-btn (click)="closeDialog(cont.value)" padding="8px"><span class="tutor-btn-txt">{{cont.str}}</span></app-btn>
                    }

                    

                }

            }

        </span>
    </div>
</div>